
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class FranchiseeGrid extends Serenity.EntityGrid<FranchiseeRow, any> {
        protected getColumnsKey() { return FranchiseeColumns.columnsKey; }
        protected getDialogType() { return FranchiseeDialog; }
        protected getIdProperty() { return FranchiseeRow.idProperty; }
        protected getInsertPermission() { return FranchiseeRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeRow.localTextPrefix; }
        protected getService() { return FranchiseeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);


            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: FranchiseeService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new FranchiseeExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push({
                title: 'Download Franchisee Sample',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Workspace/Users/FranchiseeImportSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });
            return buttons;
        }
    }
}